import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as awards from '../../awards'

export const RESOURCE = {
  payload: {
    description:
      'A funding agreement providing financial support for research, typically from a sponsor, that occurs over a period of time.',
    dimension: awards.RESOURCE.payload,
    level: 0,
    name: 'Award',
    partialId: PartialId.Standard.create('award'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
